import { type ConnectedProps, connect } from 'react-redux';

import { getBrowser } from '../../domain/state/browser/selectors';
import { isMapView as getIsMapView } from '../../domain/state/map/selectors';

import { MapWrapper } from './MapWrapper';

const mapStateToProps = (state) => ({
  browser: getBrowser(state),
  isOpen: getIsMapView(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(MapWrapper);
